import { graphql } from "@/gql"

/** @public Spread by fragment name, which codegen resolves; no import needs the binding. */
export const UserDataFieldsFragment = graphql(`
  fragment UserDataFields on user_data {
    person_id
    org_id
    data
    view_settings
  }
`)

// Fetches current user's data (row-level permission returns only own row)
export const fetchUserData = graphql(`
  query fetchUserData {
    user_data {
      ...UserDataFields
    }
  }
`)

// Replace the caller's data. `where: {}` matches every row visible under the
// row-level permission filter, which is the caller's own row: user_data is
// per membership (person_id, org_id from the session), not per users.id.
export const updateUserData = graphql(`
  mutation updateUserData($data: jsonb!) {
    update_user_data(where: {}, _set: { data: $data }) {
      returning {
        ...UserDataFields
      }
    }
  }
`)

// Merge one key into view_settings via jsonb `_append` (a shallow `||`),
// instead of replacing the whole column. Two views saving concurrently each
// touch only their own key, so one can never clobber the other's write.
// `where: {}` matches every row visible under the row-level permission
// filter, i.e. exactly the caller's own row.
export const appendUserViewSetting = graphql(`
  mutation appendUserViewSetting($entry: jsonb!) {
    update_user_data(where: {}, _append: { view_settings: $entry }) {
      affected_rows
    }
  }
`)

// Remove one top-level key from view_settings via jsonb `_delete_key`.
export const deleteUserViewSettingKey = graphql(`
  mutation deleteUserViewSettingKey($key: String!) {
    update_user_data(where: {}, _delete_key: { view_settings: $key }) {
      affected_rows
    }
  }
`)

// Fallback for a user with no user_data row yet (append/delete_key above only
// match existing rows). update_columns: [] makes the on_conflict branch a
// no-op — this never overwrites view_settings, even if a concurrent writer's
// insert (for a *different* key) already created the row a moment earlier.
// Callers must re-run the append after this; it only guarantees a row exists.
export const ensureUserDataRow = graphql(`
  mutation ensureUserDataRow {
    insert_user_data_one(
      object: { view_settings: {} }
      on_conflict: { constraint: user_data_pkey, update_columns: [] }
    ) {
      person_id
    }
  }
`)
